/**
 * Архив 1С, сопряжение загрузчика по коду (20.10.2026; как OAuth device flow, RFC 8628): один алфавит кода у API
 * (apps/api/src/routes/archive-1c-pair) и EO-панели (вкладка «Загрузка 1С»).
 * Код показывает загрузчик на компьютере владельца, владелец набирает его в мини-приложении на телефоне. Алфавит —
 * 9 букв, одинаковых в латинице и кириллице (A C E H K M P T X), и 7 цифр без 0, 1, 8 (путаются с O, I/L, B):
 * код набирается в любой раскладке и любом регистре, похожих знаков нет. 6 знаков (16^6 ≈ 16,8 млн), вид «K7M-42X».
 */
export const PAIR_ALPHABET = "ACEHKMPTX2345679";
export const PAIR_CODE_LEN = 6;

/** Кириллица-двойник → латиница (после toUpperCase). */
const CYR: Readonly<Record<string, string>> = { "А": "A", "С": "C", "Е": "E", "Н": "H", "К": "K", "М": "M", "Р": "P", "Т": "T", "Х": "X" };
const SEP = /[\s\-‐-―_.·]/g;

/** Набранное без разделителей: верхний регистр, кириллица-двойник → латиница (знаки вне алфавита остаются как есть). */
export function cleanPairInput(input: string): string {
  return [...input.toUpperCase().replace(SEP, "")].map((ch) => CYR[ch] ?? ch).join("");
}

/** Ввод человека → 6 знаков алфавита; регистр, раскладка, пробелы и дефисы неважны. Иначе null. */
export function normalizePairCode(input: unknown): string | null {
  if (typeof input !== "string" || input.length > 40) return null;
  const s = cleanPairInput(input);
  return s.length === PAIR_CODE_LEN && [...s].every((ch) => PAIR_ALPHABET.includes(ch)) ? s : null;
}

/** «K7M42X» → «K7M-42X» (короче 4 знаков — как есть). */
export function formatPairCode(code: string): string {
  return code.length > 3 ? `${code.slice(0, 3)}-${code.slice(3)}` : code;
}
